type LabelAlignment = "center" | "flex-end";

export function setLabelsStyles(labels: HTMLLabelElement[], height: string, alignItems: LabelAlignment) {
  labels.forEach((label) => {
    label.style.height = height;
    label.style.alignItems = alignItems;
  });
}
